import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class PapersService {

    urlPrefix = 'api/paper';

    constructor(private backend: BackendService) {}

    getPaperList(id: any): Observable<any> {
        const url = `${this.urlPrefix}/property/${id}?withFiles=true`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    updateParperStatus(paperId: number, data: any): Observable<any> {
        const url = `${this.urlPrefix}/${paperId}`;
        return this.backend.put(url, data).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
